import script from "./InterviewForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./InterviewForm.vue?vue&type=script&setup=true&lang=ts"

import "./InterviewForm.vue?vue&type=style&index=0&id=23a06d2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23a06d2a"]])

export default __exports__